module.exports = __webpack_public_path__ + "img/1-13.a87a15f1.png";